module.exports = __webpack_public_path__ + "img/User.83a8b799.svg";